type TimeModel = {
  hour: string;
  minute: string;
  period: 'AM' | 'PM';
};

function parseFrom12hToTimeModel(time: string): TimeModel {
  const [hourStr, rest] = time.split(':');
  const [minute, period] = rest.split(' ');

  let hour = parseInt(hourStr, 10);

  if (hour >= 12) {
    if (hour > 12) hour -= 12;
  } else if (hour === 0) {
    hour = 12;
  }

  return {
    hour: hour.toString().padStart(2, '0'),
    minute,
    period: period as 'AM' | 'PM',
  };
}

function parseTimeTo24h({ hour, minute, period }: TimeModel): string {
  let h = parseInt(hour, 10);

  if (period === 'PM' && h !== 12) {
    h += 12;
  }

  if (period === 'AM' && h === 12) {
    h = 0;
  }

  return `${h.toString().padStart(2, '0')}:${minute}`;
}

function parseDateTo12h(isoString: string): string {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) throw new Error('Data inválida');

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12 || 12;
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${hours}:${paddedMinutes} ${period}`;
}

export { parseDateTo12h, parseFrom12hToTimeModel, parseTimeTo24h };
